export enum RatesViewActions {
  NBG = 'nbg',
  Commercial = 'comm',
  Limits = 'limits',
  Live = 'live',
}

export enum RatesAddActions {
  Add = 'add',
  Delete = 'delete',
}

interface GetNBGRatesAttributes {
  action: RatesViewActions.NBG
  StartDate: string
  EndDate: string
  CCY: string
}

type GetCommercialRatesAttributes = Omit<GetNBGRatesAttributes, 'action'> & {
  action: RatesViewActions.Commercial
  CCY2: string
  NodeID: number
  TypeID: number
}

interface GetRatesLimits {
  action: RatesViewActions.Limits
}

interface GetRateViewLiveAttributes {
  OperTypeID: number
  NodeID: number
  action: RatesViewActions.Live
}

export type GetRatesAttributes =
  | GetNBGRatesAttributes
  | GetCommercialRatesAttributes
  | GetRatesLimits
  | GetRateViewLiveAttributes

type Currency = 'GEL' | 'USD'

export interface CommercialRate {
  ID: number
  CCY: Currency
  CCY2: Currency
  CCY2Title: string
  CCYTitle: string
  CCY_Rate_TypeTitle: string
  CurrentRate: number
  LoginFull: string
  NodeID: number
  RateBuy: number
  RateSell: number
  RegDate: string
  RegDate2: string
  SHN_NodeAlias: string
  SHN_NodeTitle: string
  TypeID: number
  Units: number
}

export interface NBGRate {
  ID: number
  CCY: Currency
  CCY2: Currency
  LoginFull: string
  Rate: number
  RegDate: string
  SEC_UserID: number
  Units: number
}

export enum RatesServiceErrorCode {
  GENERAL,
}

export interface RatesFailure {
  message: string
}

export interface AddNBGRateAttributes {
  RegDate: string
  Units: string
  CCY: string
  CCY2: string
  Rate: string
}

export interface DeleteNBGRateAttributes {
  ID: number
  CCY: string
  CCY2: string
  RegDate: string
  Units: string
  Rate: string
}

export interface AddCommercialRateAttributes {
  RegDate: string
  Units: string
  CCY: string
  CCY2: string
  RateBuy: string
  RateSell: string
  TypeID: number
  NodeID: number
  NodeGroupID: number
}

export interface DeleteCommercialRateAttributes {
  ID: number
  RegDate: string
}
